import type {LocationQuery} from 'vue-router';

export type TQueryObjectValue = undefined | null | boolean | string | number;

export interface IQueryObject {
  [key: string]: TQueryObjectValue | TQueryObjectValue[];
}

const delimiter = '&';
const getQueryPath = (key: string, value: NonNullable<TQueryObjectValue>) => {
  const currentKey = encodeURIComponent(key);
  const currentValue = encodeURIComponent(value.toString());
  return currentKey + '=' + currentValue;
};

// eslint-disable-next-line valid-jsdoc
/**
 * Метод сериализации объекта в query string
 * @typedef {type} T - Тип объекта для сериализации
 * @param {T} obj - Объект для сериализации
 * @return {Array<keyof T>} - query string
 **/
export function serializeFromObjectToQueryString<
  T extends IQueryObject | LocationQuery,
>(obj: T) {
  return Object.entries(obj)
    .filter(([, value]) => {
      return (
        value != null &&
        value !== '' &&
        (Array.isArray(value) ? !!value.length : true)
      );
    })
    .map(([key, value]) => {
      if (Array.isArray(value))
        return value
          .map((item) => getQueryPath(key, item as string))
          .join(delimiter);
      else return getQueryPath(key, value as string);
    })
    .join(delimiter);
}

export const serializeObjectToFlatObject = (obj?: object, prefix?: string) => {
  let entries: [string, unknown][] = [];

  Object.entries(obj ?? {}).forEach(([key, value]) => {
    switch (typeof value) {
      case 'object':
        if (value == null) entries.push([key, value]);
        else if (Array.isArray(value)) {
          const arr = Object.fromEntries(
            value.map((item, index) => [index.toString(), item]),
          );

          entries.push(
            ...Object.entries(serializeObjectToFlatObject(arr, key)),
          );
        } else {
          entries.push(
            ...Object.entries(serializeObjectToFlatObject(value, key)),
          );
        }
        break;
      default:
        entries.push([key, value]);
    }
  });

  if (prefix) {
    entries = entries.map(([key, value]) => {
      return [[prefix, key].filter((item) => !!item).join('.'), value];
    });
  }

  return Object.fromEntries(entries);
};
